<template lang="html">
  <!-- <div class="serve-info" v-if="hasAddress"> -->
  <div class="serve-info">
    <div class="order-address">
      <div class="order-address-title pf-medium">地址信息</div>
      <p class="order-address-f pf-simbold">
        <i class="order-address-icon"></i>
        <span>{{ worker.userName }}</span>
        <span class="order-address-phone">{{
          worker.contact.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
        }}</span>
      </p>
      <p class="order-address-s">地址：{{ worker.address }}</p>
    </div>
  </div>
</template>

<script>
import { SKUTAG } from '@/plugins/enum'

export default {
  props: {
    worker: {
      type: Object,
      default() {
        return {}
      }
    },
    area: {
      type: String,
      default: ''
    },
    order: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {},
  computed: {
    // hasAddress(){
    //     // 打标为自营到店 和 pop到店 不显示服务地址和地址icon
    //     return +this.order.skuTag == SKUTAG.SELFSTORE || +this.order.skuTag == SKUTAG.POPSTORE ? false : true
    // },
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.serve-info {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);

  .order-address {
    padding: rem(32px) rem(24px) rem(30px) rem(24px);
    border-radius: rem(16px);
    background: #fff;
    font-size: rem(24px);
    color: #262626;
    line-height: rem(30px);
    margin-bottom: rem(20px);

    .order-address-title {
      font-size: rem(30px);
      padding: 0 0 rem(30px) 0;
    }

    &-f {
      display: flex;
      align-items: center;
      font-size: rem(26px);
      color: #121212;
      font-weight: 500;
      height: rem(36px);
      line-height: rem(36px);
      margin-bottom: rem(12px);
    }

    &-s {
      margin-left: rem(44px);
    }

    &-icon {
      display: inline-block;
      background: url('../../assets/images/order/icon-address.png') center
        center;
      background-size: rem(36px) rem(36px);
      width: rem(36px);
      height: rem(36px);
      margin: 0 rem(8px) 0 0;
    }

    &-phone {
      margin-left: rem(16px);
    }
  }

  .iconfont {
    font-size: rem(40px);
  }
  .item-cell {
    // align-items: flex-start;
    @include border(bottom);

    &:first-child {
      .item-cell-bd {
        padding-right: rem(100px);
        p:first-of-type {
          font-size: rem(32px);
          font-weight: bold;

          .phone {
            margin-left: rem(15px);
          }
        }
        p:last-of-type {
          margin-top: rem(15px);
          line-height: 1.5;
          color: #666;
        }
      }
    }
    .item-cell-hd {
      // align-self: flex-start;
      align-self: center;
      color: inherit;
    }
    &::after {
      left: rem(20px);
    }
    &:last-child {
      &::after {
        border: 0;
      }
    }
  }
  .show-mobile {
    color: #666;
    font-size: rem(32px);
    a {
      color: inherit;

      &:last-child {
        color: #666;
        font-size: rem(26px);
      }
    }
    .icon-dianhua {
      color: #ff397e;
      margin-left: rem(50px);
      margin-right: rem(10px);
      font-size: rem(30px);
    }
  }
}
</style>
